// extracted by mini-css-extract-plugin
export default {"providers":"SocialLoginButtons_providers__d9NFy","provider":"SocialLoginButtons_provider__NAlMs"};